const IndustryEnum = {
  MaxSelectedCompanies: 20
}

export default IndustryEnum
